import { Button } from '@connected/ui/components/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@connected/ui/components/dialog';
// TESTING
import { Block } from '@tanstack/react-router';

import { useFormContext } from '../../hooks/use-form-context';

export function Blocker() {
    const form = useFormContext();
    return (
        <form.Subscribe
            selector={state => ({
                isDirty: state.isDirty,
                isSubmitted: state.isSubmitted,
            })}
        >
            {({ isDirty }) => (
                <>
                    <Block
                        shouldBlockFn={() => isDirty}
                        withResolver
                        enableBeforeUnload={false}
                    >
                        {({ status, proceed, reset }) => (
                            <>
                                {status === 'blocked' && (
                                    <Dialog
                                        open={status === 'blocked'}
                                        onOpenChange={() => reset()}
                                    >
                                        <DialogContent className="sm:max-w-[425px]">
                                            <DialogHeader>
                                                <DialogTitle>Unsaved Changes</DialogTitle>
                                            </DialogHeader>
                                            <div className="py-4">
                                                <p>
                                                    Are you sure you want to leave? Your changes will be
                                                    lost.
                                                </p>
                                            </div>
                                            <DialogFooter>
                                                <Button variant="outline" onClick={reset}>
                                                    No, stay
                                                </Button>
                                                <Button onClick={proceed}>Yes, leave</Button>
                                            </DialogFooter>
                                        </DialogContent>
                                    </Dialog>
                                )}
                            </>
                        )}
                    </Block>
                </>
            )}
        </form.Subscribe>
    );
}
